import { render, staticRenderFns } from "./cmp-br-catalog.vue?vue&type=template&id=13e534c8&"
import script from "./cmp-br-catalog.vue?vue&type=script&lang=ts&"
export * from "./cmp-br-catalog.vue?vue&type=script&lang=ts&"
import style0 from "./cmp-br-catalog.vue?vue&type=style&index=0&id=13e534c8&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./cmp-br-catalog.vue?vue&type=custom&index=0&blockType=vue-filename-injector"
if (typeof block0 === 'function') block0(component)

export default component.exports